export function isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
export function getCookie(key) {
    var arr;
    var reg = new RegExp("(^| )".concat(key, "=([^;]*)(;|$)"));
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    }
    return '';
}
export function objectToString(params) {
    return Object.keys(params)
        .map(function (key) {
        var value = params[key];
        if (typeof value === 'object') {
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(JSON.stringify(value)));
        }
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    })
        .join('&');
}
